import Icon from '@mui/icons-material/People';

import { CreateUser } from './CreateUser';
import { EditUser } from './EditUser';
import { ListUsers } from './ListUsers';

export const UsersResourceConfig = {
  create: CreateUser,
  list: ListUsers,
  icon: Icon,
  name: 'users',
  edit: EditUser,
};
